import './SmsMulti_sendMenu.scss';
import * as S from '../scss/theme';
import React, { useState, useEffect, useRef } from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import fnc from '../mymod/commFunction';
import HongButton from '../comm/HongButton';
import HongDtpicker from '../comm/HongDtpicker';
import HongTimePicker from '../comm/HongTimePicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import SmsResult from '../page_smsResult/SmsResult';

const SmsMulti_sendMenu = ({list_sms, setList_sms}) => {

    const [optValueTarget, setOptValueTarget] = React.useState('all'); 
    const [optValueSchedule, setOptValueSchedule] = React.useState('reserve'); 
    const [startDate, setStartDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(() => {
      const time = new Date();
      time.setHours(17, 0, 0, 0); // 오후 5시로 설정
      return time;
    });
    const [isModal_smsResult, setIsModal_smsResult] = useState(false);
    

    //------------------------라디오 그룹
    const handleChangeRadioGroup = (event) => {
      setOptValueTarget(event.target.value); // 라디오 버튼 선택 시 상태 업데이트
      // console.log(event.target.value); // 선택된 값을 콘솔에 출력
    };

    // 새로운 라디오 그룹 핸들러 (즉시 예약)
    const handleChangeScheduleGroup = (event) => {
      setOptValueSchedule(event.target.value); // 새로운 상태 업데이트
      // console.log(event.target.value); // 선택된 값을 콘솔에 출력
    };

    const handleTimeChange = (time) => {
      setSelectedTime(time);
    };

    //------------------------------------------------문자전송(SMS)
    function onSendMsg() {
      let stCode, stName, hp, hp_parent, content;

      const cnt = list_sms.filter((item) => item.isChecked).length;
      if (cnt < 1) {
        alert('대상을 선택하세요!');
        return;
      }
      const confirmMessage = `총 ${cnt}명에게 문자를 전송하시겠습니까?`;
      if (!window.confirm(confirmMessage)) {
        return; 
      }

      const category = '출결';
      const gangsaName = fnc.getCookie('userName') || '';

      let sentCount = 0; 

      list_sms.map((item) => {
        
        if (item.isChecked) {
          stCode = item.stCode;
          stName = item.name;
          hp = item.hp;
          hp_parent = item.hp_parent;
          content =  item.content;
       
          fncSendMsg1(stCode, stName, hp, hp_parent, content, category, gangsaName, () => {
            sentCount += 1;
            // 모든 전송이 완료되었는지 확인
            if (sentCount === cnt) {
              alert(`총 ${sentCount}개의 문자가 성공적으로 전송되었습니다. \n성공 여부는 문자내역에서 확인하시기 바랍니다!`);            
              }
          });
        }
      });
    }

    function fncSendMsg1(stCode, stName, hp, hp_parent, content, category, gangsaName, callback) {
      let sendDate;
      const now_reserve = optValueSchedule;
      const all_student_parent = optValueTarget;
      let reservationType;

      if (now_reserve === 'now') {
        sendDate = fnc.getNow();
        reservationType = '즉시';
      } else if (now_reserve === 'reserve') {
        sendDate = fnc.formatDate(startDate) + " " + fnc.formatTime(selectedTime)
        reservationType = '예약';
      } else {
        alert('즉시, 예약 에러');
        return;
      }
      //---------------------------------------------------------------------
      content = `${stName} 학생 ${content}`;
      if (all_student_parent === 'student') {
        stName = `${stName}`;
        fncSendMsg2(sendDate, reservationType, hp, stCode, stName, content, category, gangsaName, callback);
      } else if (all_student_parent === 'parent') {
        stName =  `${stName} 부모`;
        fncSendMsg2(sendDate, reservationType, hp_parent, stCode, stName, content, category, gangsaName, callback);

      } else if (all_student_parent === 'all') {
        stName =  `${stName}`;
        fncSendMsg2(sendDate, reservationType, hp, stCode, stName, content, category, gangsaName, callback);
        
        stName =  `${stName} 부모`;
        fncSendMsg2(sendDate, reservationType, hp_parent, stCode, stName, content, category, gangsaName, callback);

      }

    }

    function fncSendMsg2(sendDate, reservationType, hp, stCode, stName, content, category, gangsaName, callback) {//순서 조심
      const acaCode = fnc.getCookie('acaCode');
      
      const recivePhone = hp;
      const msgContent = content;
      // const category = '출결';
      //--------------------------------------------------------
      const sendPhoneNumber = process.env.REACT_APP_sendPhone;
      const senderPhone = sendPhoneNumber; //'01093871431';
      const originalSenderPhone = senderPhone;

      // // 핸드폰 번호 유효성 검사 (한국 휴대전화 형식)
      // const phoneRegex = /^01[016789]-?\d{3,4}-?\d{4}$/;
      // if (!phoneRegex.test(recivePhone)) {
      //   console.log("유효하지 않은 핸드폰 번호:", recivePhone);
      //   return; // 유효하지 않은 경우 함수 종료
      // }

      // 유효하지 않은 경우 처리
      if (!fnc.isValidPhoneNumber(recivePhone)) {
        // console.log("유효하지 않은 핸드폰 번호:", recivePhone);
        return; // 유효하지 않은 경우 함수 종료
      }

      fnc.sendAxios('/kuesbSmsRoutes/insert/sms', { 
        recivePhone, // 받는사람 (수신자 전화번호)
        senderPhone, // 보낸사람 (발신자 전화번호)
        sendDate,
        msgContent, //전송 메시지
        originalSenderPhone, //보낸사람 (원래 발신자)
        acaCode, 
        reservationType,
        stCode, //(ETC8)
        stName, //성명
        gangsaName, //담임
        category, //항목(ETC7)
      }, (res) => {

        callback(); // 콜백 호출
        // console.log(res, Array.isArray(res) ? 'sms' : "kuesbSmsRoutes/insert/sms");
      });
    
    }
  

    //=========================================
    return (

      <>
      <div className="SmsMulti_sendMenu">
        <div className="wrap-main">
        
          <article className='article-option'>
              <div className='option-target'>
                  <RadioGroup row value={optValueTarget} onChange={handleChangeRadioGroup} >
                    <FormControlLabel value="all" control={<Radio />} label="모두" />
                    <FormControlLabel value="student" control={<Radio />} label="학생" />
                    <FormControlLabel value="parent" control={<Radio />} label="부모" />
                  </RadioGroup>
              </div>

              {/* 즉시 예약 라디오 그룹 */}
              <div className='option-schedule'>
                  <RadioGroup row value={optValueSchedule} onChange={handleChangeScheduleGroup}>
                    <FormControlLabel value="now" control={<Radio />} label="즉시" />
                    <FormControlLabel value="reserve" control={<Radio />} label="예약" />
                  </RadioGroup>
              </div>

            </article>

            <div className='date-picker'>
                <HongDtpicker selectedDate={startDate} onDateChange={(date) => setStartDate(date)} /> 
                <HongTimePicker selectedTime={selectedTime} onTimeChange={handleTimeChange} />
            </div>

            <HongButton className='btnSend h-btn-red' onClick={onSendMsg}> 
                  <i class="fa-solid fa-mobile-retro"></i> SEND
            </HongButton>
            
            <HongButton className='btnSend h-btn-green' onClick={() => setIsModal_smsResult(true)}> 
                  <i class="fa-solid fa-mobile-retro"></i> 문자내역
            </HongButton>
                
        </div>

      </div>

      {isModal_smsResult && 
        <S.Modal_fullScreen backgroundColor='white'>
            <SmsResult  setIsModal={setIsModal_smsResult} />
        </S.Modal_fullScreen>
      }

 </>
    );
}

export default SmsMulti_sendMenu;
